import InvestmentNoteDetailsModal from './InvestmentNoteDetailsModal';
import {
    useInvestmentNoteDispatch,
    useInvestmentNoteState,
} from '../../../contexts/InvestmentNoteContext';
import { useEffect, useState } from 'react';
import {
    getDownloadInvestmentMemo,
    postRetrieveInvestmentNoteDetails,
} from '../src/investmentNoteApis';

const InvestmentNoteDetails = () => {
    const investmentNoteDispatch = useInvestmentNoteDispatch();
    const investmentNoteState = useInvestmentNoteState();

    const [investmentNote, setInvestmentNote] = useState();
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        // if (investmentNoteState.investmentNote) {
        //     setIsFetching(true);
        //     postRetrieveInvestmentNoteDetails();
        //     setIsFetching(false);
        // }

        setInvestmentNote(investmentNoteState.investmentNote);
    }, [investmentNoteState.investmentNote]);

    const downloadInvestmentMemo = (investmentNote) => {
        setIsFetching(true);
        getDownloadInvestmentMemo(investmentNote);
        setIsFetching(false);
    };

    return (
        <InvestmentNoteDetailsModal
            isOpen={
                investmentNoteState.showInvestmentNoteDetailsModal &&
                !!investmentNote
            }
            toggle={() =>
                investmentNoteDispatch({
                    type: 'closeInvestmentNoteDetailsModal',
                })
            }
            investmentNoteDetails={investmentNote || {}}
            onDownloadInvestmentMemo={downloadInvestmentMemo}
        />
    );
};

export default InvestmentNoteDetails;
